import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Location } from 'history'
import Button, { ButtonProps } from '@mui/material/Button'

interface BackButtonprops extends ButtonProps<typeof Link> {
  content?: string
}

export function BackButton({ content, ...props }: BackButtonprops) {
  const { t, i18n } = useTranslation()

  const buttonContent = content ? (i18n.exists(content) ? t(content) : content) : null

  return (
    <Button component={Link} {...props}>
      {buttonContent}
    </Button>
  )
}

BackButton.defaultProps = {
  children: 'Form.Buttons.Back',
  color: 'primary',
  variant: 'outlined',
  to: (location: Location) => location.pathname.split('/').slice(0, -1).join('/')
}
